import { Star } from "lucide-react";

/**
 * PressStrip — muted, single-tone typographic wordmark strip of
 * publications the firm has been quoted in / contributed to. Uses
 * typography (small-caps serif in slate) instead of image logos so
 * there are no trademark concerns; publications are rendered exactly
 * as text and can be swapped freely.
 */
export default function PressStrip({ publications = [], kicker = "As Featured In", className = "" }) {
  if (!publications || publications.length === 0) return null;
  return (
    <div className={`${className}`} data-testid="press-strip">
      <div className="flex items-center gap-4 justify-center mb-8">
        <span className="h-px w-14 bg-brass/50" />
        <Star size={9} className="text-brass fill-brass shrink-0" />
        <span className="text-[10px] uppercase tracking-[0.36em] text-brass font-medium">
          {kicker}
        </span>
        <Star size={9} className="text-brass fill-brass shrink-0" />
        <span className="h-px w-14 bg-brass/50" />
      </div>

      <div
        className="flex flex-wrap items-center justify-center gap-y-6 divide-x divide-brass/25"
        data-testid="press-strip-marks"
      >
        {publications.map((name, i) => (
          <span
            key={i}
            className="px-6 md:px-8 text-[13px] md:text-sm text-slate2/85 font-display uppercase tracking-[0.28em] whitespace-nowrap hover:text-navy transition-colors duration-500"
            style={{ fontVariant: "small-caps" }}
            data-testid={`press-strip-${i}`}
          >
            {name}
          </span>
        ))}
      </div>
    </div>
  );
}
